module.exports = __webpack_public_path__ + "img/8.388afd2e.jpg";